<template>
  <div class="cesta">
    <v-container>
      <v-row>
        <v-col>
          <v-breadcrumbs :items="items" :divider="'|'" class="py-0">
            <template v-slot:item="props">
              <v-breadcrumbs-item :href="props.item.href" :class="[props.item.disabled && 'disabled']"><span
                  style="color: black;"
                  v-bind:class="{bold : props.item.text == 'Carrito de Compra'}">{{  props.item.text }}</span>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center">
          <h1 class="PTSerif" style="font-size: 20px;">Carrito de Compra</h1>
        </v-col>
      </v-row>

      <v-row style="min-height: calc(100vh - (90px + 72px + 42px + 54px + 282px));">
        <v-col>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr id="table-carrito">
                  <th class="d-none d-md-table-cell"></th>
                  <th class="text-center text-md-left title-table">Producto</th>
                  <th class="d-none d-md-table-cell text-center text-md-left title-table">Cantidad</th>
                  <th class="text-center text-md-left title-table">Precio</th>
                  <th class="d-none d-md-table-cell"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,i) in cart" :key="i" height="77px">
                  <td class="py-2" style="position:relative;">
                    <span class="d-block d-md-none" style="position:absolute; margin-top: 25px;"
                      @click="eliminar_producto(i)">
                      <v-icon style="font-size: 10px;">mdi-close</v-icon>
                    </span>
                    <v-img :src="'https://flordeazaharcms.actstudio.xyz/'+item.producto.cover.path" width="56"
                      height="56" class="d-block mx-auto mx-md-none"></v-img>
                    <span class="d-block d-md-none text-center text-md-left">{{ item.producto.name }}</span>

                    <div class="d-flex justify-center d-md-none mx-0 mx-md-5 px-3 py-1"
                      style="background-color: #EFEDE9; border-radius: 30px;">
                      <button @click="restar(i)" style="font-size: 16px">–</button>
                      <input type="text" v-model="item.cantidad" class="d-inline-block"
                        style="width: 30px; text-align: center; font-size: 12px;" />
                      <button @click="sumar(i)" style="font-size: 16px">+</button>
                    </div>

                  </td>
                  <td class="d-none d-md-table-cell">
                    <span class="d-none d-md-block">{{ item.producto.name }}</span>
                  </td>
                  <td class="d-none d-md-table-cell">
                    <div class="my-4">
                      <label for="cantidad" class="Roboto bold d-none d-md-inline-block">Elige la cantidad</label>

                      <div class="d-flex justify-center d-md-inline-block mx-0 mx-md-5 px-3 py-1"
                        style="background-color: #EFEDE9; border-radius: 30px;">
                        <button @click="restar(i)" style="font-size: 16px">–</button>
                        <input type="text" v-model="item.cantidad" class="d-inline-block"
                          style="width: 30px; text-align: center; font-size: 12px;" />
                        <button @click="sumar(i)" style="font-size: 16px">+</button>
                      </div>
                    </div>
                  </td>
                  <td class="text-center text-md-left">
                    <template v-if="descuento != null">
                      <span class="d-block" style="text-decoration: line-through;">${{ item.producto.precio }} MXN</span>

                      <span>${{ aplicar_descuento(item.producto.precio) }} MXN</span>
                    </template>
                    <template v-else>
                      <span>${{ item.producto.precio }} MXN</span>
                    </template>
                  </td>
                  <td class="text-center">
                    <span @click="eliminar_producto(i)" style="cursor:pointer;">
                      <v-icon>mdi-close</v-icon>Eliminar
                    </span>
                  </td>
                  <!-- <td>{{ item.producto.precio * item.cantidad}}</td> -->
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td class="d-none d-md-table-cell"></td>
                  <td class="text-center text-md-left">${{ sumarTotal }} MXN</td>
                </tr>
                <!-- <tr v-if="">
                </tr> -->
              </tbody>
            </template>
          </v-simple-table>

          <v-row justify="start" justify-md="end" align="center">

            <v-col cols="auto" style="max-width: 250px; width: 250px;">
              <v-text-field label="Código de descuento" flat v-model="codigo_descuento">
              </v-text-field>
            </v-col>
            <v-col cols="1">
              <v-btn elevation="0" color="#e4cfa6" rounded @click="aplicar()">Aplicar</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="py-0">
      <v-row>
        <v-col class="px-0 py-0">
          <router-link to="/checkout" class="not-underline">
            <v-btn block color="#56604D" dark tile>Realizar pedido</v-btn>
          </router-link>
          <router-link to="/tienda" class="not-underline">
            <v-btn block color="#B4613D" dark tile>Seguir comprando</v-btn>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Vue from "vue";
  import VueSession from "vue-session";
  Vue.use(VueSession, {
    persist: true
  });
  export default {
    data() {
      return {
        items: [{
            text: "Inicio",
            disabled: false,
            href: "/"
          },
          {
            text: "Carrito de Compra",
            disabled: true
          }
        ],
        cart: [],
        codigo_descuento: '',
        descuento: null,
      };
    },
    beforeMount: function(){
      var promocion = this.$session.get('descuento');

      var aux = this;

          fetch(
            "https://flordeazaharcms.actstudio.xyz/api/collections/get/Descuentos?token=bd38a532024ddfd195a5fdefd8eb98", {
              method: "post",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                filter: {
                  codigo: promocion.codigo
                },
              })
            }
          )
          .then(res => res.json())
          .then(function(res){

            console.log(res.entries);
            var found = false;
            found = res.entries.find(element => new Date(element.fecha_inicio) <= new Date() && new Date(element.fecha_fin) >= new Date() );

            console.log(promocion.codigo);
            console.log('aaa');
            console.log(found);
            console.log('bbb');

            if (typeof found !== 'undefined' && found.codigo == promocion.codigo){
              aux.$session.set('descuento',res.entries[0]);
            }else{
              aux.$session.remove('descuento');
            }


        });
    },
    created: function () {
      this.cart = this.$session.get("cart");
      this.descuento = this.$session.get('descuento');
    },
    methods: {
      eliminar_producto: function (i) {
        this.cart.splice(i, 1);

        this.$session.set("cart", this.cart);
        this.$emit("updated");
      },
      restar: function (i) {
        if (this.cart[i].cantidad > 1) {
          this.cart[i].cantidad--;
          this.$session.set("cart", this.cart);
          this.$emit("updated");
        }
      },
      sumar: function (i) {
        this.cart[i].cantidad++;
        this.$session.set("cart", this.cart);
        this.$emit("updated");
      },
      aplicar_descuento: function(precio){
        if(this.descuento != null){
          var desc = 100 - this.descuento.descuento;
          desc = desc * .01;
          return precio * desc;
        }
      },
      aplicar: function () {
        var aux = this;
        fetch(
            "https://flordeazaharcms.actstudio.xyz/api/collections/get/Descuentos?token=bd38a532024ddfd195a5fdefd8eb98", {
              method: "post",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                filter: {
                  codigo: this.codigo_descuento
                },
              })
            }
          )
          .then(res => res.json())
          .then(function(res){
            var found = false;
            found = res.entries.find(element => new Date(element.fecha_inicio) <= new Date() && new Date(element.fecha_fin) >= new Date() );
          


            if (typeof found !== 'undefined'){
              aux.descuento = res.entries[0];
              console.log(res.entries[0].descuento);              

              aux.$session.set('descuento',res.entries[0]);
            }else{
              aux.descuento = null;
              aux.$session.set('descuento', []);
            }


          });
      }
    },
    computed: {
      sumarTotal() {
        var total = 0;
        for (var x = 0; x < this.cart.length; x++) {
          total += this.cart[x].cantidad * this.cart[x].producto.precio;
        }

        if(this.descuento != null){
          var desc = 100 - this.descuento.descuento;
          desc = desc * .01;
          return total * desc;
        }

        return total;
      },
    }
  };
</script>